import {sys_finance_demand} from "@/api/financeDemand";

export default {
    data(){
        return {
            needYear:''
        }
    },
    mounted() {
        this.getFinancialNeedsYear()
    },
    methods:{
        getFinancialNeedsYear(){
            this.getAction({
                url: sys_finance_demand.getYear,
                params:{}
            }).then(res => {
                this.needYear = res
            })
        },
    }
}
